"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalBorrowerChargeFields = void 0;
var FinalBorrowerChargeFields;
(function (FinalBorrowerChargeFields) {
    FinalBorrowerChargeFields["AcceptableAmount"] = "acceptableAmount";
    FinalBorrowerChargeFields["AcceptableDate"] = "acceptableDate";
    FinalBorrowerChargeFields["AdjustedAmount"] = "adjustedAmount";
    FinalBorrowerChargeFields["AdjustedDate"] = "adjustedDate";
    FinalBorrowerChargeFields["Code"] = "code";
    FinalBorrowerChargeFields["Comment"] = "comment";
    FinalBorrowerChargeFields["IndexNumber"] = "indexNumber";
    FinalBorrowerChargeFields["OriginalClaimSequenceNumber"] = "originalClaimSequenceNumber";
    FinalBorrowerChargeFields["PreviouslyApprovedAmount"] = "previouslyApprovedAmount";
    FinalBorrowerChargeFields["PreviouslyApprovedComment"] = "previouslyApprovedComment";
    FinalBorrowerChargeFields["PreviouslyApprovedDate"] = "previouslyApprovedDate";
    FinalBorrowerChargeFields["PreviouslyReceivedAmount"] = "previouslyReceivedAmount";
    FinalBorrowerChargeFields["PreviouslyReceivedDate"] = "previouslyReceivedDate";
    FinalBorrowerChargeFields["ReceivedAmount"] = "receivedAmount";
    FinalBorrowerChargeFields["ReceivedDate"] = "receivedDate";
    FinalBorrowerChargeFields["AccruedInterestCalculations"] = "accruedInterestCalculations";
    FinalBorrowerChargeFields["CreditReceiptInterestCalculation"] = "creditOfReceiptInterestCalculation";
})(FinalBorrowerChargeFields = exports.FinalBorrowerChargeFields || (exports.FinalBorrowerChargeFields = {}));
